/*
 * df-capture.js — Popup de captacion de email con criterio.
 *
 * La idea de fondo: un popup que sale a los tres segundos se cierra sin leerlo,
 * y ademas quema el contacto para siempre — el visitante ya ha aprendido que
 * esta web le interrumpe. Asi que este no se dispara por tiempo: se dispara por
 * interes acumulado.
 *
 * Tres capas, en este orden:
 *
 *   1. PUNTUACION. Cada senal de interes (scroll, paginas, fichas de producto,
 *      tocar el personalizador, buscar, volver otro dia) suma puntos. Se guarda
 *      en sessionStorage, asi que sobrevive a la navegacion entre paginas.
 *
 *   2. MOMENTO. Con los puntos ya por encima del umbral, todavia no sale: espera
 *      a un hueco natural — intencion de salida, final de pagina, o cuatro
 *      segundos de quietud despues de haber estado activo. Interrumpir a alguien
 *      que esta leyendo es lo que hace que se cierre en automatico.
 *
 *   3. BLOQUEOS. Y por encima de todo, una lista de situaciones donde no sale
 *      nunca: ya suscrito, ya dicho que no, carrito, checkout, otro modal
 *      abierto, escribiendo en un campo, bot / Lighthouse.
 *
 * El formulario se envia de forma NATIVA, con recarga de pagina. No es pereza:
 * la tienda tiene la proteccion anti-spam activada y el token de captcha solo lo
 * rellena Shopify en el envio nativo — por fetch devuelve 403. Se guarda el
 * scroll y el nombre antes de enviar, y al volver con ?customer_posted=true se
 * restaura la posicion y sale el aviso de exito.
 */

(function () {
  'use strict';

  var ROOT = document.getElementById('df-capture');
  if (!ROOT) return;

  var CFG = {};
  try {
    var cfgEl = document.getElementById('df-capture-config');
    CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {};
  } catch (e) { CFG = {}; }
  if (!CFG.copy) CFG.copy = {};

  var LS_KEY = 'df_cap_v1';
  var SS_KEY = 'df_cap_ses_v1';
  var SS_PENDING = 'df_cap_pending_v1';

  var QS = new URLSearchParams(location.search);
  var FORCE = QS.get('df_capture') === '1';
  var KILL = QS.get('df_nocapture') === '1';
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);

  // ==========================================================
  // Almacenamiento tolerante
  // Modo incognito y bloqueadores tiran excepcion en el propio
  // acceso a localStorage, no solo al escribir. Todo con try.
  // ==========================================================
  function read(store, key, fallback) {
    try {
      var raw = window[store].getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) { return fallback; }
  }
  function write(store, key, val) {
    try { window[store].setItem(key, JSON.stringify(val)); } catch (e) {}
  }

  var mem = read('localStorage', LS_KEY, null) || { seen: 0, nos: 0, until: 0, done: false, variant: '', name: '', mails: [] };
  if (!mem.mails) mem.mails = [];
  var ses = read('sessionStorage', SS_KEY, null) || { score: 0, pages: 0, hits: {}, shown: false, products: [], active: 0 };

  function saveMem() { write('localStorage', LS_KEY, mem); }
  function saveSes() { write('sessionStorage', SS_KEY, ses); }

  // ==========================================================
  // Variante
  // En "auto" se sortea una vez por visitante y se queda fija: ver
  // tres popups distintos en tres visitas seria de tienda rota. La
  // variante viaja luego en las tags del contacto, que es lo que
  // permite comparar cual convierte sin montar analitica aparte.
  // ==========================================================
  var VARIANTES = ['sello', 'postal', 'banda'];
  var pedida = QS.get('df_variant');
  var elegida = CFG.variant;

  if (VARIANTES.indexOf(pedida) !== -1) {
    // Para comparar los tres sin tocar los ajustes del tema.
    elegida = pedida;
  } else if (CFG.variant === 'auto') {
    if (!mem.variant || VARIANTES.indexOf(mem.variant) === -1) {
      mem.variant = VARIANTES[Math.floor(Math.random() * VARIANTES.length)];
      saveMem();
    }
    elegida = mem.variant;
  }

  if (elegida !== CFG.variant) {
    CFG.variant = elegida;
    VARIANTES.concat(['auto']).forEach(function (v) { ROOT.classList.remove('df-capture--' + v); });
    ROOT.classList.remove('df-capture--dark');
    ROOT.classList.add('df-capture--' + elegida);
    if (elegida === 'banda') ROOT.classList.add('df-capture--dark');
    ROOT.setAttribute('data-variant', elegida);
    // El velo solo lo lleva el sello, y solo el se traga el foco.
    ROOT.setAttribute('aria-modal', elegida === 'sello' ? 'true' : 'false');
    // En la banda el sello dibujado no cabe.
    if (elegida === 'banda') {
      var stamp = ROOT.querySelector('.df-capture__stamp');
      if (stamp) stamp.remove();
    }
  }

  // ==========================================================
  // Puntuacion
  // Cada senal suma una vez (la llave la marca en `hits`), salvo
  // las que llevan tope propio.
  // ==========================================================
  function add(key, points) {
    if (ses.hits[key]) return;
    ses.hits[key] = 1;
    ses.score += points;
    saveSes();
    check();
  }

  function addRepeat(key, points, cap) {
    var got = ses.hits[key] || 0;
    if (got >= cap) return;
    var give = Math.min(points, cap - got);
    ses.hits[key] = got + give;
    ses.score += give;
    saveSes();
    check();
  }

  // Visitante que vuelve: llega caliente de fabrica. Le hace falta
  // menos recorrido para que el popup tenga sentido.
  if (mem.seen > 0) add('vuelve', 15);

  // Paginas de la sesion. La segunda es la que mas dice: significa
  // que la primera no le ha echado.
  ses.pages += 1;
  saveSes();
  if (ses.pages === 2) add('pag2', 8);
  if (ses.pages > 2) addRepeat('pagN', 5, 20);

  if (CFG.template === 'product') {
    add('producto', 12);
    if (CFG.handle && ses.products.indexOf(CFG.handle) === -1) {
      ses.products.push(CFG.handle);
      saveSes();
    }
    // Comparar es decidir. Dos fichas distintas es una senal mas
    // fuerte que quedarse mucho rato en una sola.
    if (ses.products.length >= 2) add('compara', 10);
  }
  // ==========================================================
  // Interes
  // Dos tablas y no una: saber PARA QUIEN busca vale mucho mas que
  // saber si mira cuadros o tazas — casi todo el catalogo son cuadros,
  // asi que ese dato solo no separa a nadie. Se manda una etiqueta de
  // cada grupo como mucho, para no llenar la ficha de ruido.
  // ==========================================================
  var DESTINATARIO = {
    'para-parejas':    'int-pareja',
    'dia-de-la-madre': 'int-madre',
    'para-mama':       'int-madre',
    'para-papa':       'int-padre'
  };
  var FORMATO = {
    'cuadros-personalizados': 'int-cuadro',
    'tazas-magicas':          'int-taza',
    'ropa-y-accesorios':      'int-ropa',
    'complementos':           'int-complemento'
  };

  if (!ses.dest) ses.dest = {};
  if (!ses.form) ses.form = {};
  if (!ses.seq) ses.seq = 0;

  // Se guarda cuantas veces (n) y como de reciente (o). Con empate gana
  // lo ultimo que miro: quien pasa del cuadro de pareja a "para mama"
  // ha cambiado de idea, y el que manda es el segundo.
  function suma(mapa, tag) {
    var e = mapa[tag] || { n: 0, o: 0 };
    e.n += 1;
    e.o = ++ses.seq;
    mapa[tag] = e;
  }

  (CFG.colecciones || []).forEach(function (h) {
    if (DESTINATARIO[h]) suma(ses.dest, DESTINATARIO[h]);
    if (FORMATO[h]) suma(ses.form, FORMATO[h]);
  });
  saveSes();

  function masVisto(mapa) {
    var claves = Object.keys(mapa || {});
    if (!claves.length) return null;
    claves.sort(function (a, b) {
      return (mapa[b].n - mapa[a].n) || (mapa[b].o - mapa[a].o);
    });
    return claves[0];
  }

  if (CFG.template === 'search') add('busca', 10);
  if (CFG.template === 'article') add('articulo', 6);

  // ==========================================================
  // Tiempo activo
  // No vale el reloj de pared: una pestana de fondo no es interes.
  // Solo cuenta si la pestana esta visible y ha habido algun gesto
  // en los ultimos 30 segundos.
  // ==========================================================
  // Acumulado de toda la sesion y no de esta pagina: si no, quien
  // navega rapido entre fichas no llegaria nunca al minimo por mucho
  // rato que lleve dentro.
  var activeMs = ses.active || 0;
  var lastAct = Date.now();
  ['pointerdown', 'keydown', 'scroll', 'pointermove', 'touchstart'].forEach(function (ev) {
    window.addEventListener(ev, function () { lastAct = Date.now(); }, { passive: true });
  });

  setInterval(function () {
    if (document.visibilityState !== 'visible') return;
    if (Date.now() - lastAct > 30000) return;
    activeMs += 1000;
    ses.active = activeMs;
    if (activeMs % 5000 === 0) { saveSes(); addRepeat('tiempo', 2, 20); }
  }, 1000);

  // ==========================================================
  // Profundidad de scroll
  // ==========================================================
  var maxPct = 0;
  function scrollPct() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h <= 0) return 100;
    return Math.round((window.scrollY / h) * 100);
  }
  window.addEventListener('scroll', function () {
    var p = scrollPct();
    if (p <= maxPct) return;
    maxPct = p;
    if (p >= 25) add('sc25', 5);
    if (p >= 50) add('sc50', 8);
    if (p >= 75) add('sc75', 12);
  }, { passive: true });

  // ==========================================================
  // Gestos de intencion alta
  // Tocar el personalizador es lo mas cerca de comprar que se
  // puede estar sin comprar. Vale mas que cualquier otra senal.
  // ==========================================================
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('form[action*="/cart/add"], .teeinblue, [data-teeinblue], [id*="teeinblue"]')) {
      add('personaliza', 15);
    }
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-df-wishlist-toggle]')) add('deseos', 15);
    if (t.closest('[data-toggle-search], [data-df-open-search]')) add('abre-busca', 8);
    if (t.closest('summary, .df-accordion__head, details > summary')) addRepeat('despliega', 4, 12);
  }, true);

  // ==========================================================
  // Bloqueos
  // Cualquiera de estos y el popup no existe. Se comprueban en el
  // momento de abrir, no al cargar: el carrito se llena despues.
  // ==========================================================
  var BLOCKED_TEMPLATES = ['cart', 'checkout', 'password', 'gift_card'];

  // Los duros no los levanta nadie, ni siquiera ?df_capture=1. Si no,
  // al probarlo en /carrito saldria, y quien lo prueba se lleva la
  // idea equivocada de donde aparece.
  function bloqueoDuro() {
    if (KILL) return 'kill';

    var tpl = String(CFG.template || '');
    for (var i = 0; i < BLOCKED_TEMPLATES.length; i++) {
      if (tpl.indexOf(BLOCKED_TEMPLATES[i]) === 0) return 'plantilla';
    }
    if (tpl.indexOf('customers') === 0) return 'plantilla';
    // El quiz ya pide el correo al final. Dos veces es una de mas.
    if (CFG.quiz) return 'quiz';

    // Otro overlay delante: buscador, cajon de carrito, galeria.
    // El tema bloquea el scroll con .no-scroll en el body, asi que
    // esa clase vale de detector universal sin acoplarse a ninguno.
    if (document.body.classList.contains('no-scroll') && !opened) return 'otro-modal';
    // Ojo con el :not([hidden]): mira el atributo del PROPIO elemento, y
    // casi ningun overlay del tema lo lleva encima. El cajon movil, sin ir
    // mas lejos, es un <aside aria-modal="true"> dentro de un <div hidden>:
    // el aside esta siempre en el DOM y siempre sin `hidden`, asi que el
    // selector lo encontraba en todas las paginas y daba el popup por
    // bloqueado para siempre. Hay que preguntar si se ve de verdad.
    var dialogs = document.querySelectorAll('[aria-modal="true"]:not([hidden]), dialog[open]');
    for (var d = 0; d < dialogs.length; d++) {
      var dlg = dialogs[d];
      if (dlg === ROOT || ROOT.contains(dlg)) continue;
      // El `hidden` puede estar en cualquier ancestro, no solo encima.
      if (dlg.closest('[hidden]')) continue;
      // Y puede estar escondido solo por CSS: sin cajas, no tapa nada.
      if (!dlg.getClientRects().length) continue;
      return 'otro-modal';
    }

    // Bots y auditorias. Que el popup no ensucie el PageSpeed ni se
    // cuele en las capturas del rastreador.
    if (navigator.webdriver && !FORCE) return 'bot';
    if (/bot|crawl|spider|lighthouse|headless/i.test(navigator.userAgent)) return 'bot';

    // El > 0 no sobra: en una pestana que todavia no se ha maquetado
    // innerWidth vale 0, y sin el guarda el popup queda bloqueado por
    // "pantalla demasiado estrecha" en una ventana de tamano normal.
    if (window.innerWidth > 0 && window.innerWidth < 320) return 'pantalla';
    return '';
  }

  // Los blandos son los que ?df_capture=1 si levanta: son estado del
  // visitante, no sitios donde el popup este prohibido.
  function bloqueoBlando() {
    if (mem.done) return 'ya-suscrito';
    if (CFG.logged) return 'con-cuenta';
    if (Date.now() < (mem.until || 0)) return 'descansando';
    if (ses.shown) return 'ya-visto-en-esta-sesion';

    // Escribiendo en algo. Robarle el foco a alguien a media frase
    // es la forma mas rapida de que cierre sin leer.
    var ae = document.activeElement;
    if (ae && /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName)) return 'escribiendo';
    if (ae && ae.isContentEditable) return 'escribiendo';

    // Video en marcha.
    var vids = document.querySelectorAll('video');
    for (var v = 0; v < vids.length; v++) {
      if (!vids[v].paused && !vids[v].ended && !vids[v].muted) return 'video';
    }

    return '';
  }

  function blocked() { return bloqueoDuro() || bloqueoBlando(); }

  // ==========================================================
  // Momento
  // Con puntos de sobra, todavia hay que elegir el hueco.
  // ==========================================================
  var armed = false;
  var opened = false;
  var UMBRAL = Number(CFG.threshold || 30);
  // El suelo de tiempo activo es aparte del umbral: evita que alguien
  // que llega con 15 puntos de regalo por ser visitante recurrente vea
  // el popup a los tres segundos de entrar.
  var MIN_ACTIVE = Number(CFG.minActive || 12) * 1000;

  function check() {
    if (armed || opened) return;
    if (ses.score < UMBRAL) return;
    if (activeMs < MIN_ACTIVE) return;
    armed = true;
    listenForMoment();
  }

  function listenForMoment() {
    // 1 · Intencion de salida en escritorio: el puntero se va por
    //     arriba, hacia las pestanas o la barra de direcciones.
    document.addEventListener('mouseout', function (e) {
      if (e.clientY > 8) return;
      if (e.relatedTarget || e.toElement) return;
      open('salida');
    });

    // 2 · Movil: no hay mouseleave. El equivalente honesto es un
    //     scroll hacia arriba rapido despues de haber bajado —
    //     el gesto de ir a por la barra de direcciones.
    var lastY = window.scrollY;
    var lastT = Date.now();
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var t = Date.now();
      var dy = lastY - y;
      var dt = t - lastT || 1;
      if (dy > 60 && dy / dt > 1.1 && y > 300) open('salida-movil');
      lastY = y; lastT = t;
    }, { passive: true });

    // 3 · Volver a la pestana despues de haberse ido a otra cosa.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') setTimeout(function () { open('vuelve-pestana'); }, 900);
    });

    // 4 · Final de pagina y parado. Ha llegado hasta abajo: ya no
    //     le interrumpimos nada.
    var stopT;
    window.addEventListener('scroll', function () {
      clearTimeout(stopT);
      stopT = setTimeout(function () {
        if (scrollPct() >= 85) open('final');
      }, 1200);
    }, { passive: true });

    // 5 · Quietud. Cuatro segundos sin mover nada despues de haber
    //     estado activo: esta pensandoselo.
    var idleT;
    function idle() {
      clearTimeout(idleT);
      idleT = setTimeout(function () {
        if (document.visibilityState === 'visible') open('pensando');
      }, 4000);
    }
    ['pointermove', 'scroll', 'keydown', 'touchstart'].forEach(function (ev) {
      window.addEventListener(ev, idle, { passive: true });
    });
    idle();

    // 6 · Red de seguridad. Quien pasa el umbral con holgura y sigue
    //     dentro al minuto ya no va a dar un momento mejor: se le
    //     ensena antes de perderlo. Sin esto, el visitante que lee sin
    //     parar y cierra la pestana de golpe no lo ve nunca.
    setTimeout(function () {
      if (ses.score >= UMBRAL + 10) open('holgura');
    }, 60000);
  }

  // ==========================================================
  // Copia segun contexto
  // El mismo popup no puede decir lo mismo a quien acaba de ver
  // una ficha que a quien lleva algo en el carrito.
  // ==========================================================
  function contextKey() {
    if (CFG.cartCount > 0 && CFG.copy.carrito) return 'carrito';
    if (mem.seen > 1 && CFG.copy.vuelve) return 'vuelve';
    if ((CFG.template === 'product' || ses.products.length) && CFG.copy.producto) return 'producto';
    return 'base';
  }

  function applyCopy() {
    var key = contextKey();
    var head = CFG.copy[key] || CFG.copy.base;
    if (!head) return key;
    var el = ROOT.querySelector('[data-df-cap-heading]');
    if (el) el.innerHTML = head.replace(/\*(.+?)\*/g, '<em>$1</em>');
    return key;
  }

  // ==========================================================
  // Abrir y cerrar
  // ==========================================================
  var lastFocus = null;
  var protegido = false;

  function protegerFormulario() {
    if (protegido) return;
    var f = ROOT.querySelector('form');
    var cap = window.Shopify && window.Shopify.captcha;
    if (!f || !cap || typeof cap.protect !== 'function') return;
    try { cap.protect(f); protegido = true; vigilaSello(); } catch (e) {}
  }

  // ==========================================================
  // El sello de hCaptcha
  // Shopify lo planta fijo abajo a la derecha, con z-index 9999, en
  // cuanto se llama a captcha.protect() — y ya no se va solo. El
  // visitante cierra el popup y le queda el cartel flotando el resto
  // de la visita, encima de la burbuja de chat. Solo tiene sentido
  // mientras el formulario esta delante.
  //
  // Ojo con esconderlo a lo bruto: en la pagina de contacto y en el
  // alta del pie el sello es de OTRO formulario, y ese aviso hay que
  // ensenarlo. Por eso antes se mira si queda alguno a la vista.
  // ==========================================================
  var selloObs = null;

  function otroFormularioALaVista() {
    var marcas = document.querySelectorAll('.h-captcha');
    for (var i = 0; i < marcas.length; i++) {
      if (ROOT.contains(marcas[i])) continue;
      var f = marcas[i].closest('form');
      if (f && f.getClientRects().length) return true;
    }
    return false;
  }

  function sincronizaSello() {
    var sello = document.getElementById('shop-hcaptcha-badge-container');
    if (!sello) return;
    if (opened || otroFormularioALaVista()) sello.style.removeProperty('display');
    else sello.style.setProperty('display', 'none', 'important');
  }

  // El sello no llega en el mismo momento que protect(), sino cuando
  // hCaptcha termina de cargar. Por eso hay que estar al tanto en vez
  // de esconderlo una sola vez y darlo por hecho.
  function vigilaSello() {
    sincronizaSello();
    if (selloObs || typeof MutationObserver !== 'function') return;
    selloObs = new MutationObserver(sincronizaSello);
    selloObs.observe(document.body, { childList: true });
  }

  function open(reason) {
    if (opened) return;
    if (bloqueoDuro()) return;
    if (bloqueoBlando() && !FORCE) return;

    opened = true;
    ses.shown = true;
    saveSes();
    mem.seen = (mem.seen || 0) + 1;
    saveMem();

    // El contexto y la variante se guardan como tags del contacto:
    // es lo unico que el form 'customer' de Shopify conserva ademas
    // del correo y el nombre, y es justo lo que hace falta para
    // segmentar la bienvenida en Shopify Email.
    var ctx = applyCopy();
    var tags = ROOT.querySelector('[data-df-cap-tags]');
    if (tags) {
      var etiquetas = ['newsletter', 'popup-web', 'ctx-' + ctx, 'pop-' + (CFG.variant || 'sello')];
      var quien = masVisto(ses.dest);
      var que = masVisto(ses.form);
      if (quien) etiquetas.push(quien);
      if (que) etiquetas.push(que);

      // El filtro no es paranoia: la bienvenida se bifurca con "tags
      // incluye PT" comparando SUBCADENAS, asi que una etiqueta con esas
      // dos letras dentro manda al suscriptor a la rama portuguesa —
      // que esta en borrador — y se queda sin correo. Ya paso una vez
      // con `popup-captacion`. Aqui se cae sola antes de salir.
      tags.value = etiquetas.filter(function (t) {
        return t.toLowerCase().indexOf('pt') === -1;
      }).join(',');
    }

    lastFocus = document.activeElement;
    ROOT.hidden = false;
    ROOT.setAttribute('data-reason', reason);
    // Dos fotogramas: el primero pinta el estado inicial, el segundo
    // dispara la transicion. Con uno solo el navegador agrupa ambos y
    // la animacion no llega a existir.
    //
    // Y una red debajo: en una pestana que el navegador no esta
    // pintando (segundo plano, captura automatica) los fotogramas no
    // llegan nunca, y sin la clase el panel se queda en el DOM a
    // opacidad cero — presente, invisible e inutilizable. El temporizador
    // la pone igual; anadirla dos veces no hace nada.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { ROOT.classList.add('is-open'); });
    });
    setTimeout(function () { ROOT.classList.add('is-open'); }, 80);

    // El variante banda no tapa nada, asi que no bloquea el scroll.
    if (CFG.variant !== 'banda' && CFG.variant !== 'postal') {
      document.body.classList.add('no-scroll');
    }

    // hCaptcha se engancha solo, pero solo cuando el visitante toca el
    // formulario, y el nuestro nace dentro de un contenedor escondido.
    // Enlazarlo a mano al abrirlo hace que el token este preparado antes
    // de que le den a enviar: asi la comprobacion es invisible en vez de
    // acabar en la pagina de desafio.
    protegerFormulario();

    var first = ROOT.querySelector('[data-df-cap-name]') || ROOT.querySelector('[data-df-cap-email]');
    // En movil no enfocamos: abriria el teclado de golpe y taparia
    // el propio popup antes de que le diera tiempo a leerlo.
    if (first && window.matchMedia('(min-width: 768px)').matches) {
      setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 380);
    }
  }

  // ==========================================================
  // "Ya estabas dentro"
  // Solo se puede saber de quien se apunto desde ESTE navegador. Para
  // el resto haria falta preguntarle a Shopify si un correo existe, y
  // eso convierte la tienda en un comprobador de direcciones: cualquiera
  // podria averiguar quien es cliente. No se hace.
  // ==========================================================
  function yaEstaba(mail) {
    var done = ROOT.querySelector('[data-df-cap-done]');
    var form = ROOT.querySelector('form');
    var sub = ROOT.querySelector('.df-capture__sub');
    var head = ROOT.querySelector('[data-df-cap-heading]');
    if (!done || !form) return;

    if (head) head.textContent = CFG.alreadyHeading || 'Ya estabas dentro.';
    if (sub) sub.hidden = true;
    form.hidden = true;

    // El texto lleva un hueco [correo] (corchetes, no llaves: con llaves
    // Liquid corta la etiqueta) para que la frase se lea bien
    // con direccion y sin ella, y siga siendo editable desde el tema.
    var plantilla = CFG.alreadyText || 'El codigo salio a [correo]. Si no lo ves, mira en spam.';
    var slot = done.querySelector('[data-df-cap-done-text]');
    if (slot) {
      var partes = plantilla.split('[correo]');
      slot.textContent = '';
      slot.appendChild(document.createTextNode(partes[0]));
      if (partes.length > 1) {
        var b = document.createElement('b');
        b.textContent = mail || 'tu correo';
        slot.appendChild(b);
        slot.appendChild(document.createTextNode(partes.slice(1).join('[correo]')));
      }
    }
    done.hidden = false;
  }

  function close(how) {
    if (!opened) return;
    opened = false;
    ROOT.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    sincronizaSello();
    setTimeout(function () { ROOT.hidden = true; }, 320);

    // Un "no" tiene grados. Cerrar con la X o con la tecla no es lo
    // mismo que ignorarlo: el primero se respeta mas tiempo, y el
    // segundo "no" se respeta mucho mas que el primero.
    var dias;
    if (how === 'esc') {
      dias = 3;
    } else {
      mem.nos = (mem.nos || 0) + 1;
      dias = mem.nos >= 2 ? 90 : Number(CFG.snoozeDays || 5);
    }
    mem.until = Date.now() + dias * 864e5;
    saveMem();

    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  ROOT.querySelectorAll('[data-df-cap-close]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); close('x'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && opened) close('esc');
    // Trampa de foco: dentro del modal, el tabulador da vueltas.
    if (e.key === 'Tab' && opened && CFG.variant === 'sello') {
      var f = ROOT.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      var vis = [];
      for (var i = 0; i < f.length; i++) { if (f[i].offsetParent !== null) vis.push(f[i]); }
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // ==========================================================
  // Email con cabeza
  // ==========================================================
  var DOMINIOS = [
    'gmail.com', 'hotmail.com', 'hotmail.es', 'outlook.com', 'outlook.es',
    'yahoo.com', 'yahoo.es', 'icloud.com', 'me.com', 'live.com', 'msn.com',
    'proton.me', 'protonmail.com', 'gmx.es', 'aol.com', 'mac.com',
    'telefonica.net', 'movistar.es', 'terra.es', 'orange.es', 'ono.com',
    'wanadoo.es', 'yahoo.com.mx', 'gmail.es'
  ];

  var email = ROOT.querySelector('[data-df-cap-email]');
  var ghost = ROOT.querySelector('[data-df-cap-ghost]');
  var didyou = ROOT.querySelector('[data-df-cap-didyou]');
  var nameEl = ROOT.querySelector('[data-df-cap-name]');
  var nameHint = ROOT.querySelector('[data-df-cap-namehint]');

  // Limpieza de lo que llega pegado o mal tecleado. Nada de esto
  // corrige "criterio", solo destrozos mecanicos: espacios, el
  // "Nombre <correo@x.com>" de Outlook, la coma en vez del punto.
  function limpia(v) {
    return String(v || '')
      .replace(/^mailto:/i, '')
      .replace(/^.*<(.+?)>.*$/, '$1')
      .replace(/\s+/g, '')
      .replace(/,/g, '.')
      .replace(/\.{2,}/g, '.')
      .replace(/@{2,}/g, '@')
      .replace(/^\.+|\.+$/g, '')
      .toLowerCase();
  }

  function distancia(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 9;
    var prev = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      var cur = [i];
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      }
      prev = cur;
    }
    return prev[b.length];
  }

  function sugiereDominio(parcial) {
    if (!parcial) return '';
    for (var i = 0; i < DOMINIOS.length; i++) {
      if (DOMINIOS[i].indexOf(parcial) === 0 && DOMINIOS[i] !== parcial) return DOMINIOS[i];
    }
    return '';
  }

  function corrige(dominio) {
    if (!dominio || DOMINIOS.indexOf(dominio) !== -1) return '';
    var mejor = '', dist = 3;
    for (var i = 0; i < DOMINIOS.length; i++) {
      var d = distancia(dominio, DOMINIOS[i]);
      if (d < dist) { dist = d; mejor = DOMINIOS[i]; }
    }
    return dist <= 2 ? mejor : '';
  }

  var ghostFull = '';
  var ghostPre = ghost ? ghost.querySelector('[data-df-cap-ghost-pre]') : null;
  var ghostRest = ghost ? ghost.querySelector('[data-df-cap-ghost-rest]') : null;

  function pintaGhost() {
    if (!ghost || !email || !ghostPre || !ghostRest) return;
    var v = email.value;
    var at = v.indexOf('@');
    ghostFull = '';
    if (at > 0 && v.indexOf(' ') === -1 && email.selectionStart === v.length) {
      var dom = v.slice(at + 1).toLowerCase();
      var sug = sugiereDominio(dom);
      if (sug) ghostFull = v.slice(0, at + 1) + sug;
    }
    // El fantasma va detras del input, que es transparente de fondo.
    // El trozo ya escrito se pinta invisible: asi ocupa exactamente su
    // ancho y la continuacion cae donde toca sin medir nada a mano.
    // Con textContent y no innerHTML, que aqui entra texto del usuario.
    ghostPre.textContent = ghostFull ? v : '';
    ghostRest.textContent = ghostFull ? ghostFull.slice(v.length) : '';
    ghost.hidden = !ghostFull;
  }

  function aceptaGhost() {
    if (!ghostFull) return false;
    email.value = ghostFull;
    ghostFull = '';
    ghost.hidden = true;
    revisaEmail();
    return true;
  }

  function revisaEmail() {
    if (!email || !didyou) return;
    var v = email.value;
    var at = v.lastIndexOf('@');
    didyou.hidden = true;
    if (at < 1) return;
    var dom = v.slice(at + 1).toLowerCase();
    if (dom.indexOf('.') === -1) return;
    var fix = corrige(dom);
    if (!fix) return;
    var propuesta = v.slice(0, at + 1) + fix;
    didyou.hidden = false;
    var btn = didyou.querySelector('[data-df-cap-fix]');
    if (btn) {
      btn.textContent = propuesta;
      btn.onclick = function (e) {
        e.preventDefault();
        email.value = propuesta;
        didyou.hidden = true;
        adivinaNombre();
        email.focus();
      };
    }
  }

  if (email) {
    email.addEventListener('input', function () {
      pintaGhost();
      if (!didyou.hidden) didyou.hidden = true;
    });

    email.addEventListener('keydown', function (e) {
      if ((e.key === 'Tab' || e.key === 'ArrowRight' || e.key === 'End') && ghostFull) {
        // Solo si el cursor esta al final: si esta editando por el
        // medio, la flecha derecha es una flecha derecha.
        if (email.selectionStart === email.value.length) {
          e.preventDefault();
          aceptaGhost();
        }
      }
      if (e.key === 'Enter' && ghostFull) { e.preventDefault(); aceptaGhost(); }
    });

    email.addEventListener('blur', function () {
      email.value = limpia(email.value);
      if (ghost) ghost.hidden = true;
      ghostFull = '';
      revisaEmail();
      adivinaNombre();
    });

    email.addEventListener('paste', function () {
      setTimeout(function () {
        email.value = limpia(email.value);
        revisaEmail();
        adivinaNombre();
      }, 0);
    });
  }

  // ==========================================================
  // Nombre
  // Solo el de pila. El campo pide `given-name`, asi que el
  // autorrelleno del navegador ya trae uno solo; esto cubre a
  // quien lo escribe a mano.
  // ==========================================================
  function soloPila(v) {
    var t = String(v || '')
      .replace(/[0-9_@<>|\\/]+/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!t) return '';
    var partes = t.split(' ');
    // "Maria Jose" o "Juan Carlos" son un nombre, no nombre y
    // apellido. Si la segunda palabra es corta y va en la lista, se
    // queda; si no, fuera.
    var COMPUESTOS = ['jose', 'carlos', 'luis', 'antonio', 'manuel', 'maria', 'ana', 'pablo', 'javier', 'angel', 'miguel', 'del', 'de', 'la'];
    var out = [partes[0]];
    if (partes.length > 1 && COMPUESTOS.indexOf(partes[1].toLowerCase()) !== -1 && partes[0].length <= 6) {
      out.push(partes[1]);
    }
    return out.map(function (w) {
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    }).join(' ');
  }

  function adivinaNombre() {
    if (!nameEl || !email) return;
    if (nameEl.value.trim()) return;
    if (nameEl.dataset.tocado === '1') return;
    var v = email.value;
    var at = v.indexOf('@');
    if (at < 2) return;
    var local = v.slice(0, at);
    // jorge.herranz / jorge_h / jorge93 -> Jorge
    var cand = local.split(/[._\-+0-9]/)[0];
    if (!cand || cand.length < 3 || cand.length > 14) return;
    if (!/^[a-zñáéíóúü]+$/i.test(cand)) return;
    // "info", "hola", "contacto" no son nombres de nadie.
    if (['info', 'hola', 'contacto', 'admin', 'ventas', 'pedidos', 'correo', 'mail', 'no', 'noreply'].indexOf(cand) !== -1) return;
    nameEl.value = cand.charAt(0).toUpperCase() + cand.slice(1);
    nameEl.classList.add('is-guessed');
  }

  if (nameEl) {
    nameEl.addEventListener('input', function () {
      nameEl.dataset.tocado = '1';
      nameEl.classList.remove('is-guessed');
    });
    nameEl.addEventListener('blur', function () {
      var antes = nameEl.value.trim();
      var despues = soloPila(antes);
      nameEl.value = despues;
      // El aviso solo aparece si de verdad le hemos quitado algo.
      // Decirle de antemano "sin apellidos" es texto que sobra.
      if (nameHint) nameHint.hidden = !(antes && despues && antes.split(' ').length > despues.split(' ').length);
    });
  }

  // ==========================================================
  // Envio
  // Nativo, con recarga. Antes de irse se guarda donde estaba y
  // como se llama, para poder recibirle igual al volver.
  // ==========================================================
  var form = ROOT.querySelector('form');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (email) email.value = limpia(email.value);
      if (nameEl) nameEl.value = soloPila(nameEl.value);

      // stopImmediatePropagation ademas de preventDefault: hCaptcha se
      // engancha al mismo evento y se registra DESPUES que nosotros, asi
      // que cancelar el envio no le impide hacer lo suyo y llevarse al
      // visitante a /challenge. Hay que cortar la cadena entera.
      if (email && !email.checkValidity()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        email.focus();
        return;
      }
      // Mandar dos veces el mismo correo no da de alta dos veces, pero
      // el aviso de exito mentiria: no sale ningun codigo nuevo. Mejor
      // decirlo y ahorrarle la recarga.
      var mail = email ? email.value : '';
      if (mail && mem.mails.indexOf(mail) !== -1) {
        e.preventDefault();
        e.stopImmediatePropagation();
        yaEstaba(mail);
        return;
      }
      if (mail) {
        mem.mails.push(mail);
        if (mem.mails.length > 5) mem.mails.shift();
      }

      write('sessionStorage', SS_PENDING, {
        name: nameEl ? nameEl.value : '',
        y: window.scrollY,
        path: location.pathname
      });
      mem.done = true;
      mem.name = nameEl ? nameEl.value : '';
      saveMem();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    });
  }

  // ==========================================================
  // Vuelta del envio
  // ==========================================================
  (function exito() {
    var pend = read('sessionStorage', SS_PENDING, null);

    // Que vuelva con customer_posted y sin marca nuestra significa que
    // se ha apuntado por otro sitio: el pie, el quiz, la otra app. Da
    // igual por donde: ya esta en la lista y no hay que volver a
    // pedirselo. Sin esto, el popup le persigue igual.
    if (!pend && QS.get('customer_posted') === 'true' && !mem.done) {
      mem.done = true;
      saveMem();
      return;
    }

    if (!pend) return;
    // La marca en sessionStorage la pone solo este formulario, asi
    // que el aviso no sale cuando el que ha vuelto es el del pie:
    // los dos publican en /contact y los dos vuelven con
    // customer_posted, pero solo uno deja la marca.
    if (QS.get('customer_posted') !== 'true') return;
    try { window.sessionStorage.removeItem(SS_PENDING); } catch (e) {}

    if (pend.path === location.pathname && pend.y > 0) {
      window.scrollTo({ top: pend.y, behavior: 'auto' });
    }

    var toast = document.getElementById('df-capture-toast');
    if (!toast) return;
    var slot = toast.querySelector('[data-df-cap-toast-name]');
    if (slot && pend.name) slot.textContent = ', ' + pend.name;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-open'); });
    setTimeout(function () {
      toast.classList.remove('is-open');
      setTimeout(function () { toast.hidden = true; }, 400);
    }, 7000);
  })();

  // ==========================================================
  // Arranque
  // ==========================================================
  // En el editor de temas sale siempre y al momento: si no, no hay
  // manera de darle estilo.
  if (DESIGN || FORCE) {
    setTimeout(function () {
      open(DESIGN ? 'editor' : 'forzado');
      // Forzarlo estando ya suscrito enseña el estado que le tocaria,
      // no el formulario: si no, no hay forma de verlo.
      if (mem.done && FORCE) yaEstaba(mem.mails[mem.mails.length - 1] || '');
    }, 400);
  } else {
    check();
  }

  // Para poder mirarlo desde la consola sin adivinar.
  window.dfCapture = {
    abrir: function () { FORCE = true; open('manual'); },
    estado: function () {
      return { puntos: ses.score, umbral: UMBRAL, activoMs: activeMs, armado: armed, bloqueo: blocked(), memoria: mem, sesion: ses };
    },
    olvidar: function () {
      try { window.localStorage.removeItem(LS_KEY); window.sessionStorage.removeItem(SS_KEY); } catch (e) {}
      location.reload();
    }
  };
})();
